import { Divider, Typography } from "@mui/material";
import {
  NoteWrapper,
  RiskItem,
  RiskLabel,
  SubSectionTitle,
  SuccessPlanCard,
  useSpContext,
  WorkloadAssessmentView,
} from "components/summary/success-plan";
import { SuccessPlanState } from "components/summary/success-plan/state/successPlan.types";
import styles from "../SuccessPlan.module.scss";
import moment from "moment-timezone";

type WorkloadAssessmentSectionProps = {
  spState: SuccessPlanState;
};

const WorkloadAssessmentSection = ({ spState }: WorkloadAssessmentSectionProps) => {
  const { riskItems, coverageStatusItems } = useSpContext();
  const { spData } = spState;
  const {
    wemVideoDevice,
    deviceRisk,
    deviceRiskNote,
    wemSuite,
    meetingRisk,
    meetingRiskNote,
    callingRisk,
    callingRiskNote,
    wemContactCenter,
    contactCenterRisk,
    contactCenterRiskNote,
  } = spData;
  const histories = spData.histories || [];

  const deviceRiskItem: RiskItem | undefined = riskItems.find((item) => item.value === deviceRisk);
  const meetingRiskItem: RiskItem | undefined = riskItems.find(
    (item) => item.value === meetingRisk
  );
  const callingRiskItem: RiskItem | undefined = riskItems.find(
    (item) => item.value === callingRisk
  );

  const deviceFilteredHistories = histories.filter(
    (history: any) => history.fieldName === "deviceRiskNote"
  );
  const deviceNoteHistories = deviceFilteredHistories.slice(1);
  const deviceLastUpdatedOn =
    deviceFilteredHistories.length > 0
      ? moment(deviceFilteredHistories[0].lastModifiedDate)
          .tz("America/Los_Angeles")
          .format("YYYY-MM-DD HH:mm:ss PT")
      : "N/A";

  const meetingFilteredHistories = histories.filter(
    (history: any) => history.fieldName === "meetingRiskNote"
  );
  const meetingNoteHistories = meetingFilteredHistories.slice(1);
  const meetingLastUpdatedOn =
    meetingFilteredHistories.length > 0
      ? moment(meetingFilteredHistories[0].lastModifiedDate)
          .tz("America/Los_Angeles")
          .format("YYYY-MM-DD HH:mm:ss PT")
      : "N/A";

  const callingFilteredHistories = histories.filter(
    (history: any) => history.fieldName === "callingRiskNote"
  );
  const callingNoteHistories = callingFilteredHistories.slice(1);
  const callingLastUpdatedOn =
    callingFilteredHistories.length > 0
      ? moment(callingFilteredHistories[0].lastModifiedDate)
          .tz("America/Los_Angeles")
          .format("YYYY-MM-DD HH:mm:ss PT")
      : "N/A";

  return (
    <SuccessPlanCard titleSlot="Workload Assessment">
      <SubSectionTitle title="Devices Workload" />
      <div className={styles["sp-flex-horizontal"]}>
        <Typography className={styles["sp-label-gray"]}>Cloud WEM: </Typography>
        <Typography
          className={styles["sp-label"]}
          style={{
            color: coverageStatusItems.find((c) => c.label === wemVideoDevice)?.color ?? undefined,
          }}
        >
          {wemVideoDevice ?? "N/A"}
        </Typography>
      </div>
      <RiskLabel riskItem={deviceRiskItem} />
      <NoteWrapper
        riskNote={deviceRiskNote}
        noteHistories={deviceNoteHistories}
        lastUpdatedOn={deviceLastUpdatedOn}
      />
      <Divider />
      <SubSectionTitle title="Meetings Workload" />
      <div className={styles["sp-flex-horizontal"]}>
        <Typography className={styles["sp-label-gray"]}>Cloud Suite Bundle WEM: </Typography>
        <Typography
          className={styles["sp-label"]}
          style={{
            color: coverageStatusItems.find((c) => c.label === wemSuite)?.color ?? undefined,
          }}
        >
          {wemSuite ?? "N/A"}
        </Typography>
      </div>
      <RiskLabel riskItem={meetingRiskItem} />
      <NoteWrapper
        riskNote={meetingRiskNote}
        noteHistories={meetingNoteHistories}
        lastUpdatedOn={meetingLastUpdatedOn}
      />
      <Divider />
      <SubSectionTitle title="Calling Workload" />
      <div className={styles["sp-flex-horizontal"]}>
        <Typography className={styles["sp-label-gray"]}>Cloud Suite Bundle WEM:{""}</Typography>
        <Typography
          className={styles["sp-label"]}
          style={{
            color: coverageStatusItems.find((c) => c.label === wemSuite)?.color ?? undefined,
          }}
        >
          {wemSuite ?? "N/A"}
        </Typography>
      </div>
      <RiskLabel riskItem={callingRiskItem} />
      <NoteWrapper
        riskNote={callingRiskNote}
        noteHistories={callingNoteHistories}
        lastUpdatedOn={callingLastUpdatedOn}
      />
      <Divider />
      {/* Workload Assessment View for Webex Contact Center */}
      <WorkloadAssessmentView
        fieldName="contactCenterRiskNote"
        title="Webex Contact Center Workload"
        wemLbl="Cloud Contact Center WEM"
        wemValue={wemContactCenter ?? "N/A"}
        histories={histories}
        riskValue={contactCenterRisk}
        riskNote={contactCenterRiskNote}
        addDivider={false}
      />
    </SuccessPlanCard>
  );
};

export default WorkloadAssessmentSection;
